import React from 'react';

import Table from 'jsx/elements/tables/Table';
import NoRecordsFound from 'jsx/elements/messages/NoRecordsFound';
import { DisplayLimit } from 'jsx/elements/tables/DisplayLimitV2';

import { parseDate } from 'utils/date';
import { splitSsn } from 'utils/strings';
import useLocale from 'jsx/locale/useLocale';
import './ApplicationTable.less';
import { Status, statusFilceIcon } from 'components/Status';

export const ApplicationTable = ({ applications, onClick, approvedOnly = false }) => {
  const { t } = useLocale();

  if (!applications || applications.length === 0) return <NoRecordsFound />;
  return (
    <DisplayLimit
      inc={5}
      display={100}
      max={applications.length}
      render={({ count }) => {
        return (
          <Table cols={['60%', '25%']} head={['Fyrirtæki sem sótt hafa um frystingu', '']}>
            {applications.slice(0, count).map(item => {
              return (
                <tr key={item.applicationGuid}>
                  <td>
                    <span className="text-gray" style={{ marginRight: 30 }}>
                      {approvedOnly ? parseDate(item.approvalDate) : parseDate(item.lastChangeDate)}
                    </span>
                    <strong>{item.subjectName}</strong> -{' '}
                    <span className="text-gray">{splitSsn(item.subjectRegno)}</span>
                  </td>

                  <td className="text-right">
                    {approvedOnly && <Approver bank={item.approvedBy} />}
                    {approvedOnly ? (
                      <Status statusID={3} />
                    ) : (
                      <Status statusID={item.status.statusID} />
                    )}
                    {!approvedOnly && (
                      <button
                        style={{ height: 18, margin: 0, overflow: 'visible' }}
                        className="button clear t-button"
                        onClick={() => onClick(item.applicationGuid)}
                      >
                        <span
                          className={`cursor-pointer text-blue text-24 ${
                            statusFilceIcon[item.status.statusID]
                          }`}
                        />
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </Table>
        );
      }}
    />
  );
};

function Approver({ bank }) {
  return <span style={{ marginRight: 10 }}>{bank}</span>;
}
